import { render, staticRenderFns } from "./ResetEmail.vue?vue&type=template&id=efd6846a&"
import script from "./ResetEmail.vue?vue&type=script&lang=js&"
export * from "./ResetEmail.vue?vue&type=script&lang=js&"
import style0 from "./ResetEmail.vue?vue&type=style&index=0&scopped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports